<template>
    <edi-tag
      class="featured-tag"
      text="Destacado por infoLibre"
      img-src="/assets/img/svg/icons/comments-featured.svg"
    />
</template>

<script>
  import EdiTag from '../../../components/EdiTag';

  export default {
    name: 'edi-featured-comment-chip',
    components: {
      EdiTag
    }
  }
</script>
